import {
  ConversationChannelType,
  ConversationParticipantEntity,
} from '@provision/conversation-types';

const toLookup = <TEnum extends string>(values: TEnum[]): Partial<Record<string, TEnum>> =>
  Object.fromEntries(values.map((value): [string, TEnum] => [value, value]));

const PARTICIPANT_ENTITY_BY_VALUE = toLookup(Object.values(ConversationParticipantEntity));
const CHANNEL_TYPE_BY_VALUE = toLookup(Object.values(ConversationChannelType));

export const toParticipantEntity = (
  participantEntity: string,
): ConversationParticipantEntity =>
  PARTICIPANT_ENTITY_BY_VALUE[participantEntity.toLowerCase()] ??
  ConversationParticipantEntity.Unknown;

export const toConversationChannelType = (
  conversationChannelTypeId: string,
): ConversationChannelType | undefined => CHANNEL_TYPE_BY_VALUE[conversationChannelTypeId];
